export const personalInformationStepWrapperStyles = {
	marginTop: '10px',
};

export const personalInformationStepFormInputsWrapperStyles = {
	display: 'flex',
	flexDirection: 'column',
	gap: '16px',
	marginBottom: '32px',
};

export const personalInformationStepFormCheckboxesWrapperStyles = {
	display: 'flex',
	flexDirection: 'column',
	gap: '16px',
	marginTop: '1rem',
	marginBottom: '2rem',

	'& span': {
		fontSize: '0.75rem',
		lineHeight: '1rem',
		letterSpacing: 0,
		fontWeight: 400,
	},
};

export const getCheckboxChildStyles = (disabled) => {
	return {
		'& a': {
			color: disabled ? 'text.disabled' : 'text.interactive',
		},
	};
};

export const personalInformationStepFormConfirmButton = {
	display: 'flex',
	alignItems: 'center',
	gap: '8px',
	margin: '1rem auto 0',
};
